// ** Imports createContext function
import React, {createContext, useState} from 'react'
import {useSelector} from "react-redux"
import _ from 'lodash'
import moment from "moment/moment"
import * as yup from 'yup'

import {phpToMomentFormat} from "@utils"

// ** Create Context
const GlobalDefinitionsContext = createContext()

const GlobalDefinitionsProviderWrapper = ({children}) => {
	const dateFormat = useSelector(state => _.get(state, 'app.settings.app.date_format'))

	yup.addMethod(yup.string, 'dateFormat', function () {
		return this.transform(function (value, originalValue) {
			return moment(value).format(phpToMomentFormat(dateFormat))
			// return isMoment(value) ? moment(value).format(format) : originalValue
		})
	})

	return (
		<GlobalDefinitionsContext.Provider value={{}}>
			{children}
		</GlobalDefinitionsContext.Provider>
	)
}

export {GlobalDefinitionsProviderWrapper, GlobalDefinitionsContext}
